import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import Monster from '../game/Monster';
import gameData from '../gameData';
import { musicUp } from '../JingleController';
import SoundAssetKeys from '../SoundAssetKeys';
import { dotPop } from '../Utilities';
import Game from './Game';
import ABCyaLib from '@abcya/abcya_lib';

export default class Results extends Phaser.Scene
{
    static get KEY() { return 'Results'; }

    constructor()
    {
        super({ key: (Results).KEY });
    }

    init()
    {
        this.title = null;
        this.btnPlayAgain = null;
        this.monster = null;

        this.lblContainer = null;
        this.lblResultContainer = null;
        this.lblBestContainer = null;
    }

    create()
    {
        musicUp(this);

        this.add.image(0, 0, "bg").setOrigin(0);

        this.title = ABCyaPhaser.Images.addImage(0, 0, "Title", this).setOrigin(0.5);
        this.btnPlayAgain = ABCyaPhaser.Images.addImage(0, 0, "BtnPlayAgain", this).setOrigin(0.5).setScale(0);

        this.title.x = this.scale.width / 2;
        this.title.y = 144;

        this.btnPlayAgain.x = this.scale.width / 2;
        this.btnPlayAgain.y = this.scale.height - 100;
        this.btnPlayAgain.setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickPlayAgain, this);

        this.monster = new Monster(this);

        this.lblContainer = this.add.container();
        if (gameData.userData.didWin === true)
        {
            let bestScore = gameData.userData.bestScore;
            // note: the lower the score, the better
            if (gameData.userData.score < bestScore || bestScore === 0)
            {
                bestScore = gameData.userData.score;
                gameData.userData.bestScore = gameData.userData.score;
                ABCyaLib.Storage.saveObject("feed_me_fractionsbestScore", gameData.userData.bestScore.toString());
            }
            let bt = ABCyaPhaser.Text.addText(0, 0, 40, 0xffffff, FontKeys._asapbold, "You met the goal size in " + gameData.userData.score + " seconds!", this, true).setOrigin(0.5, 0);

            this.lblContainer.add(bt);

            let bscore = ABCyaPhaser.Text.addText(0, bt.height+5, 40, 0xffffff, FontKeys._asapbold, "Your best time is " + bestScore + " seconds!", this, true).setOrigin(0.5, 0);

            this.lblContainer.add(bscore);
        }
        else
        {
            let l = ABCyaPhaser.Images.addImage(0, 0, "Label_NiceTry", this).setOrigin(0.5);
            this.lblContainer.add(l);
            this.monster.frown();
        }

        this.lblContainer.x = this.scale.width / 2;

        this.monster.x = this.scale.width / 2 - this.monster.workingWidth / 2;
        this.monster.y = this.scale.height / 2 - this.monster.workingHeight / 2 + 80;
        this.lblContainer.y = this.monster.y - this.lblContainer.getBounds().height - 8;

        dotPop(this.btnPlayAgain);
        this.add.existing(this.monster);
    }

    clickPlayAgain()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        this.scene.start(Game.KEY);
    }

    update(time, dt)
    {
        this.monster.tick(dt / 1000);
    }
}